// Dependencies
import { FC } from "react";

// Components
import CategoryItem from "../CategoryItem";

// Types
import { TCategoryList } from "~/types";
import { DefaultCategory } from "~/enums";

// Styles
import { StyledTreeView } from "./CategoryList.styled";

interface CategoryListProps {
  data: TCategoryList[];
  value: number | string;
  index: number | string;
  onSelect: Function;
}

const CategoryList: FC<CategoryListProps> = ({
  data,
  value,
  index,
  onSelect,
}) => {
  return (
    <StyledTreeView hidden={value !== index} role="tabpanel">
      {data?.map((item) => (
        <CategoryItem
          id={item.id}
          label={item.name}
          icon={DefaultCategory[item.id]?.icon}
          onSelect={onSelect}
          key={item.id}
        >
          {!!item?.child.length &&
            item.child?.map((subItem) => (
              <CategoryItem
                id={subItem.id}
                label={subItem.name}
                icon={DefaultCategory[subItem.id]?.icon}
                child
                onSelect={onSelect}
                key={subItem.id}
              />
            ))}
        </CategoryItem>
      ))}
    </StyledTreeView>
  );
};

export default CategoryList;
